import React from 'react';
import PropTypes from 'prop-types';
import { gettext } from '@eventbrite/i18n';
import { makePropType } from '@eventbrite/eds-utils';
import has from 'lodash/has';
import isString from 'lodash/isString';
import isNumber from 'lodash/isNumber';

import { Pencil } from '@eventbrite/eds-iconography';

export const CUSTOM_PROPERTY_DISPLAY_SUFFIX = 'Display';
const CUSTOM_DISPLAY_PROPERTY_REGEX = new RegExp(
    `${CUSTOM_PROPERTY_DISPLAY_SUFFIX}$`,
);

const isInvalidItemProp = (key, value) => {
    if (CUSTOM_DISPLAY_PROPERTY_REGEX.test(key)) {
        return false;
    }

    return !(isString(value) || isNumber(value));
};

const ITEM_TYPE_CHECK = (props, propName) => {
    let error;
    const item = props[propName];

    if (!has(item, 'id')) {
        error = new Error('Invalid PropType supplied. Must have an id field.');
    }

    const invalidItemProperties = Object.keys(item).filter((key) =>
        isInvalidItemProp(key, item[key]),
    );

    if (invalidItemProperties.length) {
        error = new Error(
            `Invalid PropType (${invalidItemProperties.join(
                ', ',
            )}). Values must be either type String or Number.`,
        );
    }

    return error;
};

export const ITEM_TYPE = makePropType(ITEM_TYPE_CHECK);

export const COLUMN_SHAPE = PropTypes.shape({
    fieldName: PropTypes.string.isRequired,
    fieldLabel: PropTypes.node.isRequired,
    isEditable: PropTypes.bool,
    isSortable: PropTypes.bool,
    isFilterable: PropTypes.bool,
    isClickable: PropTypes.bool,
});

export const COLUMNS_PROP_TYPE = PropTypes.arrayOf(COLUMN_SHAPE);

export const EDIT_ACTIONTYPE = 'edit';
export const SELECT_ACTIONTYPE = 'select';
export const CLICK_ACTIONTYPE = 'click';

export const EDIT_ACTION = {
    value: EDIT_ACTIONTYPE,
    content: gettext('Edit'),
    iconType: <Pencil />,
};
